import slidesGeneratorFeedback from './slidesGeneratorFeedback.module'
import AIOpenEndedGrouping from './open-ended-grouping.module'

export default {
  slidesGeneratorFeedback,
  AIOpenEndedGrouping,
}
